import React from "react";
import { Chart } from '@scuf/charts';
import { Slider } from '@scuf/common';
import "@scuf/common/honeywell-dark/theme.css";
import '@scuf/charts/honeywell-dark/theme.css'

export default class Gauge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0
        };
    }

    handleOnChange = (dato) => {
        if (!isNaN(dato.val)) {
            this.setState({ value: dato.val });
            this.props.onDato(dato);
        }
        else {
            this.props.onRemoveDato(dato);
        }

        if (dato.val === "") {
            this.props.onRemoveDato(dato);
        }
    }

    handleValue(a, b) {
        return a === b
    }


    componentWillMount() {
        var nvalue = ""
        this.props.items.map((item) =>
            nvalue = item.value
        )
        this.setState({ value: nvalue == '' ? 0 : nvalue });
    }

    render() {
        const { value } = this.state;
        var idGrupo = this.props.idGrupo
        return (
            <div>
                {this.props.items.map((item) => (
                    <React.Fragment>
                        <Chart showTooltips={false}>
                            <Chart.Pane />
                            <Chart.Gauge data={[{ y: value }]} useDial={true} dial={[{ backgroundColor: "red" }]}>
                                <Chart.CenterBlock>
                                    <span style={{ fontSize: '2rem' }}>{value < 40 ? "Recarga" : value > 60 ? "Sobrecarga" : "Normal"}</span>
                                </Chart.CenterBlock>
                            </Chart.Gauge>
                            <Chart.YAxis variant="gauge">
                                <Chart.PlotBand from={0} to={39} variant="gauge" color="red" />
                                <Chart.PlotBand from={40} to={60} variant="gauge" color="green" />
                                <Chart.PlotBand from={61} to={100} variant="gauge" color="red" />
                            </Chart.YAxis>
                        </Chart>
                        <Slider label="&nbsp;&nbsp;0"
                            min={0}
                            max={100}
                            value={this.state.value}
                            onChange={value => {
                                this.setState({ value });
                            }}

                            onChange={(value) => this.handleOnChange({ key: idGrupo, id: item.id, val: value })}
                            fluid
                        />
                    </React.Fragment>
                ))}
            </div >

        );
    }
}



